app.views.paymentStatus = app.views.base.extend({
  init: function init(data) {
    this.pushPaymentToDataLayer(data);
  },
  pushPaymentToDataLayer: function pushPaymentToDataLayer(data) {
    window.dataLayer = window.dataLayer || [];
    $(window).on("load", function () {
      window.dataLayer.push({
        'event': 'payment_completed',
        'payment': {
          'order_code': data.orderCode,
          'transaction_id': data.orderCode,
          'status': data.orderStatusString,
          'type': data.orderPlanTypeString,
          'total': data.orderTotal,
          'payment_frequency': data.orderPaymentFrequency,
          'initial_payment_date': data.orderInitialPaymentDate,
          'payment_method': data.orderPaymentMethod,
          'payment_provider': data.orderPaymentProvider,
          'instalments': {
            'total': data.orderTotalNumberOfInstalments,
            'regular_amount': data.orderRegularPaymentAmount,
            'final_amount': data.orderFinalPaymentAmount
          }
        }
      });
    });
  }
});